import { MultiStepForm, cn } from "web-design-system";
import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import IdForm from "./id-form";
import { CreatePasswordForm } from "./create-password";
import { BankDetailsForm } from "./bank-details";
import { NomineeDetails } from "./nominee-details";
import { AuthSplitLayout } from "./auth-split-layout";
import { SignupSuccess } from "./signup-success";

const steps = ["ARN details", "Create password", "Bank details", "Nominee"];

const REDIRECT_DELAY_MS = 1800;

function SignupProgressBar({ currentStep }: { currentStep: number }) {
  return (
    <div className="flex gap-1.5">
      {steps.map((_, idx) => (
        <div
          key={idx}
          className={cn(
            "h-1 flex-1 rounded-full",
            idx <= currentStep ? "bg-primary" : "bg-secondary"
          )}
        />
      ))}
    </div>
  );
}

export default function DistributorOnboarding({
  defaultStep = 0,
}: {
  defaultStep?: number;
}) {
  const [isComplete, setIsComplete] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (isComplete) {
      timeout = setTimeout(() => {
        navigate({ to: "/" });
      }, REDIRECT_DELAY_MS);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isComplete, navigate]);

  return (
    <AuthSplitLayout>
      {isComplete ? (
        <SignupSuccess />
      ) : (
        <div className="flex flex-col w-full h-full gap-5">
          <span className="text-2xl font-semibold">Become a partner</span>
          <MultiStepForm
            defaultStep={defaultStep}
            initialData={{}}
            progressBar={SignupProgressBar}
          >
            <IdForm />
            <CreatePasswordForm />
            <BankDetailsForm />
            <NomineeDetails onComplete={() => setIsComplete(true)} />
          </MultiStepForm>
        </div>
      )}
    </AuthSplitLayout>
  );
}
